var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointSelection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 25,
  viewBox: "0 0 24 25"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "rjvfixh65a",
  width: "163.8%",
  height: "158%",
  x: "-31.9%",
  y: "-23.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "i91p07scbb",
  d: "M13.83 20.12c-2.228 0-4.516-.022-4.867-.024-.169-.171-1.005-.899-1.476-1.716-.347-.64-.964-2.152-1.122-2.593-.133-.371-1.029-1.709-1.599-2.327-.049-.055-1.223-1.338-1.17-2.21.036-1.028 1.457-2.358 2.562-2.046.558.13 1.137.611 1.585 1.072-.03-2.071-.052-5.791.171-6.396.371-1.005 1.211-1.005 1.57-1.005 1.092 0 1.82.648 1.947 1.733.025.215.032 1.702.032 3.252.986-.43 2.645-.203 2.727.936.475-.191 1.07-.176 1.294-.163.601.009 1.493.27 1.575 1.033 2.55-.557 2.484 3.038 1.816 4.772-.556 1.186-1.293 4.427-2.318 5.608l-.055.06c-.457.018-1.605.014-2.673.014"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i91p07scbb",
  fill: "#000",
  filter: "url(#rjvfixh65a)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i91p07scbb",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M9.303 19.248c.913.008 5.283.042 6.755.006.892-1.172 1.516-4.151 2.038-5.154.27-.742.504-2.305.147-3.122-.176-.402-.586-.621-1.117-.472-.022.047-.032 1.672-.036 1.852l-.76.004c-.005-.218-.005-1.067-.005-1.288 0-.574.045-1.104-.173-1.43-.129-.213-1.57-.253-1.767.011-.035.067-.06.256-.076.51.02.549.013 1.044.01 1.221l-.849.02c.001-.352.005-.789.001-1.25-.007-.667.04-1.226-.174-1.439-.237-.266-1.965-.4-1.835.457l-.008 2.256-.849.004a56 56 0 0 1 .007-2.252c.003-2.097 0-4.252-.025-4.475-.077-.661-.438-.982-1.103-.982-.378 0-.618.03-.772.449-.18.319-.15 5.939-.069 8.638-.654-.888-1.649-2.452-2.678-2.78-.746-.136-1.474.786-1.52 1.268-.016.246.386.976.947 1.584.628.682 1.59 2.101 1.774 2.617.386 1.06 1.125 2.963 2.137 3.747m4.526.872c-2.227 0-4.515-.022-4.866-.024-.169-.171-1.005-.899-1.476-1.716-.347-.64-.964-2.152-1.122-2.593-.133-.371-1.029-1.709-1.599-2.327-.049-.055-1.223-1.338-1.17-2.21.036-1.028 1.457-2.358 2.562-2.046.558.13 1.137.611 1.585 1.072-.03-2.071-.052-5.791.171-6.396.371-1.005 1.211-1.005 1.57-1.005 1.092 0 1.82.648 1.947 1.733.025.215.032 1.702.032 3.252.986-.43 2.645-.203 2.727.936.475-.191 1.07-.176 1.294-.163.601.009 1.493.27 1.575 1.033 2.55-.557 2.484 3.038 1.816 4.772-.556 1.186-1.293 4.427-2.318 5.608l-.055.06c-.457.018-1.605.014-2.673.014"
}))));
export default SvgPointSelection;